// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skl-ai-config {
  padding: 8px 0 20px;
}

.skl-tabs {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.skl-panel {
  padding: 20px;
}

.skl-card {
  margin-bottom: 20px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #fff;
}

.skl-card__body {
  padding: 20px;
}

.skl-summary-row {
  display: grid;
  grid-template-columns: 170px minmax(0, 1fr);
  gap: 16px;
  align-items: center;
  min-height: 42px;
  padding: 6px 0;
}

.skl-summary-row + .skl-summary-row {
  border-top: 1px solid #edf0f2;
}

.skl-actions {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 20px;
}

.skl-table-wrap {
  border: 1px solid #edf0f2;
  border-radius: 4px;
  overflow: hidden;
}

.skl-table-row {
  display: grid;
  grid-template-columns: 0.8fr 1fr 1fr 0.8fr 0.9fr;
}

.skl-table-row--header {
  background: #f8f9fa;
}

.skl-table-row--data + .skl-table-row--data {
  border-top: 1px solid #edf0f2;
}

.skl-table-cell {
  display: flex;
  align-items: center;
  min-height: 50px;
  padding: 12px 16px;
}

@media (max-width: 767.98px) {
  .skl-summary-row {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  .skl-actions {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .skl-table-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/ai-config/ai-config-skeleton/ai-config-skeleton.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,2CAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,gDAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE;IACE,0BAAA;IACA,QAAA;EACF;EAEA;IACE,2BAAA;IACA,eAAA;EAAF;EAGA;IACE,gDAAA;EADF;AACF","sourcesContent":[".skl-ai-config {\n  padding: 8px 0 20px;\n}\n\n.skl-tabs {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.skl-panel {\n  padding: 20px;\n}\n\n.skl-card {\n  margin-bottom: 20px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background: #fff;\n}\n\n.skl-card__body {\n  padding: 20px;\n}\n\n.skl-summary-row {\n  display: grid;\n  grid-template-columns: 170px minmax(0, 1fr);\n  gap: 16px;\n  align-items: center;\n  min-height: 42px;\n  padding: 6px 0;\n}\n\n.skl-summary-row + .skl-summary-row {\n  border-top: 1px solid #edf0f2;\n}\n\n.skl-actions {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.skl-table-wrap {\n  border: 1px solid #edf0f2;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.skl-table-row {\n  display: grid;\n  grid-template-columns: 0.8fr 1fr 1fr 0.8fr 0.9fr;\n}\n\n.skl-table-row--header {\n  background: #f8f9fa;\n}\n\n.skl-table-row--data + .skl-table-row--data {\n  border-top: 1px solid #edf0f2;\n}\n\n.skl-table-cell {\n  display: flex;\n  align-items: center;\n  min-height: 50px;\n  padding: 12px 16px;\n}\n\n@media (max-width: 767.98px) {\n  .skl-summary-row {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n\n  .skl-actions {\n    justify-content: flex-start;\n    flex-wrap: wrap;\n  }\n\n  .skl-table-row {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
